var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dps-group"},[_c('ul',[_c('li',{staticClass:"dps-group-header"},[_c('div',[_c('label',{attrs:{"for":this.group.id}},[_c('strong',[_vm._v(_vm._s(this.group.name))])])])]),_vm._v(" "),_vm._l((_vm.media),function(medium){return _c('medium-item',{key:medium.name,attrs:{"medium":medium,"onSelected":_vm.selectedMedium}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8f8710","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupItem.vue
// module id = 34
// module chunks = 0